/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Email_InvalidInputs */

const en_case_validation_email_invalid = /** @type {(inputs: Case_Validation_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

const pt_br2_case_validation_email_invalid = /** @type {(inputs: Case_Validation_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um e-mail válido.`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Case_Validation_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_email_invalid = /** @type {((inputs?: Case_Validation_Email_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Email_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_email_invalid(inputs)
	return pt_br2_case_validation_email_invalid(inputs)
});